<template>
  <canvas />
</template>

<script>
export default {
  name: 'AverageChart',
  props: {
    value: {
      type: Number,
      default: 0
    },
    widthValue: {
      type: Number,
      default: 0
    },
    heightValue: {
      type: Number,
      default: 0
    }
  },
  watch: {
    value() {
      this.draw()
    },
    widthValue() {
      this.draw()
    },
    heightValue() {
      this.draw()
    }
  },
  mounted() {
    this.ctx = this.$el.getContext('2d')
    this.draw()
  },
  methods: {
    draw() {
      this.$el.width = this.widthValue
      this.$el.height = this.heightValue
      this.ctx.strokeStyle = '#E9446A'
      this.ctx.beginPath()
      this.ctx.moveTo(this.value, 0)
      this.ctx.lineTo(this.value, this.heightValue)
      this.ctx.stroke()
    }
  },
}
</script>
